const features = [
  {
    title: '漫蛙漫画跳章',
    desc: '长连载也能想跳就跳，告别从头翻到尾，直接定位到目标章节继续阅读。',
    icon: 'ri-speed-up-line',
    tone: 'primary',
  },
  {
    title: '目录跳转',
    desc: '完整目录一键展开，分卷折叠结构清晰，任意章节点击即达。',
    icon: 'ri-file-list-3-line',
    tone: 'accent',
  },
  {
    title: '章节直达',
    desc: '两级定位：先选卷、再点章，阅读位置精确到页，进度随心跳跃。',
    icon: 'ri-corner-up-right-double-line',
    tone: 'secondary',
  },
  {
    title: '进度同步',
    desc: '跨设备自动同步最新阅读位置，换手机也能无缝续读。',
    icon: 'ri-refresh-line',
    tone: 'accent',
  },
];

const toneMap = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function Features() {
  return (
    <section id="features" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-block rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
            阅读功能
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            追更效率翻倍的核心体验
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            围绕「读得快、找得准」打造的跳章、目录跳转与分卷阅读能力，让每一部长篇漫画都不再难啃。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <div className="relative overflow-hidden rounded-2xl bg-background-100 p-6 md:row-span-2 md:p-8">
            <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-primary-100"></div>
            <div className="relative">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-rocket-line text-2xl" aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading text-2xl font-bold text-foreground-950">跳到你想看的地方</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                无论是追到最新话，还是回看经典桥段，漫蛙漫画的跳章都能帮你精确落位。
                不用记住看到第几页，进度随心跳跃，一章都不错过。
              </p>
              <a
                href="#volumes"
                className="mt-6 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-800"
              >
                体验分卷阅读
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform hover:-translate-y-1"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${toneMap[f.tone]}`}>
                <i className={`${f.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}